<div class="password-input-wrapper">
  <div class="password-input-element" [class.password-input]="props.toggleMask">
    @if (props.toggleMask) {
      <div class="display-password-toggle" (click)="displayToggle()">
        <i [class]="isPasswordTypeText() ? props.hideIcon : props.showIcon"></i>
      </div>
    }

    <cap-input
      [autocomplete]="props.autocomplete"
      [class]="'cap-password ' + props.styleClass"
      [type]="isPasswordTypeText() ? 'text' : 'password'"
      [placeholder]="props.placeholder"
      [readonly]="props.readonly"
      [disabled]="props.disabled"
      [styleClass]="props.styleClass"
      [label]="props.label"
      [formControl]="formControl"
      (keyup)="onKeyUp($event)"
      (input)="onInputEvent($event)"
      (blur)="onBlur($event)"
      (focus)="onFocus($event)" />
  </div>

  @if (props.enableCopy) {
    <div class="copy-password">
      <i class="mynaui-copy" (click)="copyPassword()"></i>
    </div>
  }
</div>
